import { SET_EMAIL_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

import setEmail from 'root/src/client/logic/auth/thunks/setEmail'

export default {
	[SET_EMAIL_FORM_MODULE_ID]: [
		{
			action: setEmail,
		},
	],
}
